import { render, staticRenderFns } from "./PacketsReturn.vue?vue&type=template&id=5aea2481&scoped=true"
import script from "./PacketsReturn.vue?vue&type=script&lang=js"
export * from "./PacketsReturn.vue?vue&type=script&lang=js"
import style0 from "./PacketsReturn.vue?vue&type=style&index=0&id=5aea2481&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aea2481",
  null
  
)

export default component.exports